import React from 'react';
import './index.scss';

const imgs = [
  {
    back: require('./img/back-0.png'),
  }, {
    back: require('./img/back-2.png'),
  }, {
    back: require('./img/back-1.png'),
  }, {
    back: require('./img/back-4.png'),
  }, {
    back: require('./img/back-1.png'),
  }, {
    back: require('./img/back-4.png'),
  }, {
    back: require('./img/back-1.png'),
  }, {
    back: require('./img/back-3.png'),
  },
];

const Super = () => (
  <ul className='super'>
    {
      imgs.map((item, index) => (
        <li key = { index } className={ index === 7 ? 'specail' : '' }>
          <img className='super-back' src={ item.back } />
          <div className='itemContent'>
            {
              (() => {
                if (index === 7) {
                  return (
                    <React.Fragment>
                      <div className='question'>
                        <div className='super-title'>
                          <img src={ require('./img/8title.png') } />
                        </div>
                        <div className='super-question'>
                          <div className='question-left'>
                            <ul>
                              <li>
                                <h3 className='question-left-1'>Q：超级粉丝是什么?</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①超级粉丝是虎牙推出的全新直播间身份，拥有6大特权：免费超粉卡、超粉徽章、红色昵称、粉色弹幕、升级虎粮礼包以及超级粉丝日
                                    <br />
                                    ②超粉身份与直播间绑定，可在直播间直接支付开通，按月计费
                                    <br />
                                    ③用户可同时拥有多个主播的超级粉丝
                                    <br />
                                    ④主播需通过活动获得超粉资格，拥有资格后用户才可在直播间内开通
                                  </div>
                                </section>
                              </li>
                              <li>
                                <h3 className='question-left-2'>Q：如何获得加V徽章？</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①用户开通了主播A超粉时，其拥有的主播A徽章将加V认证
                                    <br />
                                    ②一次性开通或续费12个月可以得到拥有[ V ]和[年]的超粉徽章
                                    <br />
                                    ③若用户未获得本直播间粉丝徽章，可通过开通超粉直接拥有徽章，且有加V认证
                                    <br />
                                    ④V认证与开通主播绑定，即用户拥有主播B徽章，但只开通了主播A的超粉，主播B徽章不会有加V认证
                                  </div>
                                </section>
                              </li>
                              <li>
                                <h3 className='question-left-3'>Q：超粉日是什么？</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①超级粉丝是虎牙推出的全新直播间身份，拥有6大特权：免费超粉卡、超粉徽章、红色昵称、粉色弹幕、升级虎粮礼包以及超级粉丝日
                                    <br />
                                    ②超粉身份与直播间绑定，可在直播间直接支付开通，按月计费
                                    <br />
                                    ③用户可同时拥有多个主播的超级粉丝
                                    <br />
                                    ④主播需通过活动获得超粉资格，拥有资格后用户才可在直播间内开通
                                  </div>
                                </section>
                              </li>
                            </ul>
                          </div>
                          <div className='question-right'>
                            <ul>
                              <li>
                                <h3 className='question-right-1'>Q：如何开通/续费超级粉丝？</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①用户通过支付6元/月的费用，即可在指定直播间开通超级粉丝
                                    <br />
                                    ②用户可以在直播间内续费超级粉丝。每续费一个月，超级粉丝有效期增加一个月。有效期上限2年，超过2年不会再增加有效期限
                                    <br />
                                    ③开通/续费六个月赠送一个月超级粉丝时长,开通/续费十二个月赠送三个月超级粉丝时长
                                    <br />
                                    ④开通/续费超级粉丝后,可以免费得到超级粉丝卡，每30天赠送一张，有效期30天。首次开通立刻获得，额外获赠有效期内不能获得免费超粉卡
                                    <br />
                                    <span style={{fontWeight: 'bold'}}>⑤请用户理解，平台为主播提供开播等互联网服务并根据平台规则对主播的直播行为进行平台治理，如因主播违规、主播跳槽等原因导致直播间不再开播，用户已购买的超级粉丝无法退款，平台也不折价赔偿，请用户理性消费</span>
                                  </div>
                                </section>
                              </li>
                              <li>
                                <h3 className='question-right-2'>Q：超粉卡是什么？</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①超粉卡是超粉专属礼物，仅当前直播间超粉可送，未开通超粉/其他直播间超粉无法在本直播间送出
                                    <br />
                                    ②超粉卡将以主播名字命名，赠送可以获得双倍亲密度
                                    <br />
                                    ③直播间新增超粉卡榜单，根据赠送超粉卡的数量排序
                                  </div>
                                </section>
                              </li>
                              <li>
                                <h3 className='question-right-3'>Q：超粉虎粮礼包是什么??</h3>
                                <section className='question-answer'>
                                  <div className='question-answer-left'>
                                    A:
                                  </div>
                                  <div className='question-answer-right'>
                                    ①开通超级粉丝后，每日上线可以获得额外的10个超粉虎粮，有效期1天
                                    <br />
                                    ②开通多个超级粉丝，每个直播间都可获得10个超粉虎粮，仅当前直播间可用
                                  </div>
                                </section>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                }
                return (
                  <React.Fragment>
                    <div className={ 'super-left' }>
                      <img src={ require(`./img/${index + 1}left.png`) }/>
                    </div>
                    <div className={ 'super-right' }>
                      <img src={ require(`./img/${index + 1}right.png`) }/>
                    </div>
                  </React.Fragment>
                )
              })()
            }
          </div>
        </li>
      ))
    }
  </ul>
)
export default Super;
